/*
 * Purpose: P1 — redirect authed users from landing to dashboard
 * Last modified: 2026-06-28 | Agent
 * Completeness: 90
 */
import { useEffect, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

export function AuthedHomeRedirect({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const authed = useAuthStore((s) => s.authed);
  const activeTenant = useAuthStore((s) => s.activeTenant);
  const tenantPickRequired = useAuthStore((s) => s.tenantPickRequired);
  const ready = useAuthStore((s) => s.ready);

  useEffect(() => {
    if (!ready) return;
    if (authed && activeTenant && !tenantPickRequired) {
      navigate('/dashboard', { replace: true });
    }
  }, [ready, authed, activeTenant, tenantPickRequired, navigate]);

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground text-sm">
        Loading…
      </div>
    );
  }

  if (authed && activeTenant && !tenantPickRequired) {
    return null;
  }

  return <>{children}</>;
}

export default AuthedHomeRedirect;
